import { all, put, takeEvery, fork } from "redux-saga/effects";
import { apiURL } from "../actions/helpers";
import axios from "axios";

// Action Types
export const WEALTH_GUIDED_REBALANCES_GET = "WGRG/GET";
export const WEALTH_GUIDED_REBALANCES_GET_SUCCESS = "WGRG/GET/SUCCESS";
export const WEALTH_GUIDED_REBALANCES_GET_FAILURE = "WGRG/GET/FAILURE";

// Action Creators
export const wealthGuidedRebalancesGet = (tier) => ({
  type: WEALTH_GUIDED_REBALANCES_GET,
  tier,
});

export const wealthGuidedRebalancesGetSuccess = (data, tier) => ({
  type: WEALTH_GUIDED_REBALANCES_GET_SUCCESS,
  data,
  tier,
});

export const wealthGuidedRebalancesGetFailure = (error, tier) => ({
  type: WEALTH_GUIDED_REBALANCES_GET_FAILURE,
  error,
  tier,
});

// Sagas
function* fetchWealthGuidedRebalances(action) {
  try {
    const { tier } = action;
    const response = yield axios.get(
      `${apiURL}/wealth-series/guided-rebalances?tier=${tier}`,
      { withCredentials: true },
    );
    yield put(wealthGuidedRebalancesGetSuccess(response.data, tier));
  } catch (error) {
    console.error("GET guided rebalances failed:", error);
    yield put(wealthGuidedRebalancesGetFailure(error));
  }
}

function* listenWealthGuidedRebalancesGet() {
  yield takeEvery(WEALTH_GUIDED_REBALANCES_GET, fetchWealthGuidedRebalances);
}

// Root Saga
export function* saga() {
  yield all([fork(listenWealthGuidedRebalancesGet)]);
}

const INIT_STATE = {
  guidedRebalancesData: {},
  loading: {},
  error: {},
};

// Reducer
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case WEALTH_GUIDED_REBALANCES_GET:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.tier]: true,
        },
        error: {
          ...state.error,
          [action.tier]: null,
        },
      };
    case WEALTH_GUIDED_REBALANCES_GET_SUCCESS:
      return {
        ...state,
        guidedRebalancesData: {
          ...state.guidedRebalancesData,
          [action.tier]: action.data,
        },
        loading: {
          ...state.loading,
          [action.tier]: false,
        },
        error: {
          ...state.error,
          [action.tier]: null,
        },
      };
    case WEALTH_GUIDED_REBALANCES_GET_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.tier]: false,
        },
        error: {
          ...state.error,
          [action.tier]: action.error,
        },
      };
    default:
      return state;
  }
};

export default reducer;
